import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppCredential } from 'src/app/models/app-credential';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { Region } from '../../models/region';
import { AppSettingsService } from '../../services/appsettings.service';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  error: any;
  today: Date = new Date();
  selectedRegion: Region;

  regions: Region[] = [];

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {
    this.loginForm = this.formBuilder.group({
      appId: ['', Validators.required],
      keyId: ['', Validators.required],
      secret: ['', Validators.required],
      region: ['', Validators.required]
    });
    this.regions = AppSettingsService.Settings.Regions;
  }

  ngOnInit() {
    
  }

  submit(credential: AppCredential) {
    this.authService.login(credential)
      .subscribe(data => {
        this.router.navigate(['integrations']);
      }, response => {
        this.error = response.error.message;
      });
  }
}
